import { CompositionGroup } from '@texas/api/endpoints/compositionGroup/compositionGroupApi';
import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const compositionVersionEvents = {
  onVersionsPatched: new SignalDispatcher(),
  onControllerVersionCreated: new SimpleEventDispatcher<CompositionGroup>(),
  onControllerVersionRestored: new SimpleEventDispatcher<CompositionGroup>(),
};
